import { jsx } from "react/jsx-runtime";
import Check from "@mui/icons-material/Check";
import { Fade, InputAdornment } from "@mui/material";
import { NO_COLOR } from "../../../../../constants.js";
import { useColorPicker } from "../../../../../hooks/useColorPicker.js";
import { NoColorChip } from "../../../../Swatch/components/NoColorChip.js";
import { NoColorIcon } from "../../../../Swatch/components/NoColorIcon.js";
import { Tooltip } from "../../../../Tooltip.js";
import { AdornmentChip } from "./AdornmentChip.js";
function HexInputAdornment(props) {
  const { localeText } = useColorPicker();
  const { color, onClick, showCopied } = props;
  if (color === NO_COLOR)
    return /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(NoColorChip, { size: 24, children: /* @__PURE__ */ jsx(NoColorIcon, {}) }) });
  return /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(Tooltip, { title: showCopied ? localeText.pickerAdornmentTooltipCopied : localeText.pickerAdornmentTooltip, children: /* @__PURE__ */ jsx(AdornmentChip, { bgcolor: color, onClick, size: 24, children: /* @__PURE__ */ jsx(Fade, { in: showCopied, timeout: 200, children: /* @__PURE__ */ jsx(
    Check,
    {
      sx: {
        aspectRatio: 1,
        color: (theme) => color ? theme.palette.getContrastText(color) : (theme.vars ?? theme).palette.common.white,
        width: "80%"
      }
    }
  ) }) }) }) });
}
export {
  HexInputAdornment
};
//# sourceMappingURL=HexInputAdornment.js.map
